import { CurrentDealState } from "Types/state";
import { REMOVE_SCHEDULE_APPOINTMENT, UPDATE_CURRENT_DEAL, UPDATE_SCHEDULE_APPOINTMENT } from "../constants";
import { OPEN_SUB_MODAL } from "src/store/constants/onlineShopper";
import { pollingSuccess } from "src/store/actions/poller";
import { getDealSuccess } from "src/store/actions/deal";
import { parse } from "date-fns";

const initialState: CurrentDealState = {
    appointment: null,
    vin: null,
};

function currentDeal(state = initialState, action: any): CurrentDealState {
    const { type, data } = action;
    switch (type) {
        case getDealSuccess.type:
        case pollingSuccess.type:
            if (action.payload.deal.appointments?.pick_up) {
                return {
                    ...state,
                    appointment: {
                        date: parse(action.payload.deal.appointments.pick_up.date, "yyyy-MM-dd", new Date()),
                        time: action.payload.deal.appointments.pick_up.time,
                    },
                };
            }
            return state;

        case UPDATE_CURRENT_DEAL:
            return {
                ...state,
                vin: data.vin,
            };

        case UPDATE_SCHEDULE_APPOINTMENT:
            return {
                ...state,
                appointment: {
                    date: data.date,
                    time: data.time,
                },
            };

        case REMOVE_SCHEDULE_APPOINTMENT:
            return {
                ...state,
                appointment: null,
            };

        case OPEN_SUB_MODAL:
            if (!data.vin) {
                return {
                    ...state,
                };
            }
            return {
                ...state,
                vin: data.vin,
            };

        default:
            return state;
    }
}

export default currentDeal;
